// extracted by mini-css-extract-plugin
export default {"customRow":"NudgeRow_customRow__DqRNR","customCell":"NudgeRow_customCell__UEKTY"};